// 中文翻译
const zh = {
  translation: {
    // 通用
    'app.name': '可视化远程监控',
    'app.login': '登录',
    'app.loginDemo': '演示登录',
    'app.register': '注册',
    'app.logout': '退出登录',
    'common.dashboard': '仪表板',
    'common.installations': '安装列表',
    'app.news': '新闻资讯',
    'news.overview': '新闻概览',
    'news.searchPlaceholder': '搜索新闻...',
    'news.searchButton': '搜索',
    'news.noNewsFound': '暂无新闻。',
    'app.shop': '商店',

    // Gallery
    'gallery.title': '安装图库',
    'gallery.share': '分享',
    'gallery.shared': '已分享',
    'gallery.pending': '待审核',
    'gallery.noImages': '暂无图片',
    'gallery.like': '点赞',
    'gallery.loginToLike': '登录后可点赞',
    'gallery.loadError': '加载图库失败',
    'common.uploadImagesSuccess': '上传成功',
    'common.uploadImagesFailed': '上传失败',
    'gallery.deleteConfirm': '确定删除这张图片吗？',
    'gallery.maxImages': '最多上传{{max}}张图片',
    'gallery.caption': '图片描述',
    'gallery.selectInstallation': '选择安装',
    'gallery.selectFiles': '选择图片文件',
    'gallery.filesSelected': '已选择 {{count}} 个文件',
    'gallery.selectInstallationAndFiles': '请选择安装和图片文件',
    'gallery.shareToGallery': '分享到公开图库',
    'gallery.myImages': '我的图片',
    'gallery.publicGallery': '公开图库',
    'gallery.unshare': '取消分享',
    'gallery.unshared': '已取消分享',
    'gallery.subtitle': '分享你的太阳能安装，激励更多人',
    'gallery.dropOrClick': '拖拽图片到这里或点击选择',
    'gallery.private': '私有',
    'gallery.selectSource': '选择图片来源',
    'gallery.takePhoto': '拍摄照片',
    'gallery.chooseFromGallery': '从相册选择',
    'gallery.captionPlaceholder': '描述您的安装...',
    'gallery.shareHint': '允许其他用户查看此照片',
    'common.uploadImagesHint': '支持 JPG、PNG 格式（最大 10MB）',

    'common.devices': '设备',
    'app.profile': '个人资料',
    'common.settings': '设置',
    'settings.verificationCode': '验证码',
    'settings.sendCode': '发送验证码',
    'settings.codeSentNotice': '验证码已发送至您的邮箱',
    'settings.codeRequired': '请输入 6 位验证码',
    'app.language': '语言',

    'app.email': '电子邮件',
    'common.password': '密码',
    'app.username': '用户名',
    'app.confirmPassword': '确认密码',
    'app.submit': '提交',
    'common.cancel': '取消',
    'common.save': '保存',
    'common.set': '写入',
    'common.delete': '删除',
    'common.add': '添加',
    'common.upload': '上传',
    'common.edit': '编辑',
    'common.search': '搜索',
    'common.filter': '筛选',
    'common.sort': '排序',
    'common.status': '状态',
    'common.online': '在线',
    'common.offline': '离线',
    'common.error': '错误',
    'common.success': '成功',
    'app.back': '返回',
    'app.home': '首页',
    'common.actions': '操作',
    'common.loading': '加载中...',
    'common.processing': '处理中...',
    'common.close': '关闭',
    'common.units': '组',
    'common.normal': '正常',
    'common.tooHigh': '过高',
    'common.tooLow': '过低',
    'common.number': '编号',
    'common.time': '时间',
    'common.overview': '概览',
    'common.details': '详情',
    'common.rowsPerPage': '每页行数',
    'common.readMore': '阅读更多',
    // Unified terms (reuse across pages)
    'common.voltage': '电压',
    'common.current': '电流',
    'common.power': '功率',
    'common.temperature': '温度',
    'common.soc': '电量',
    'common.charging': '充电中',
    'common.discharging': '放电中',
    'common.idle': '闲置',
    'common.warning': '警告',
    'common.warnState1': '警告状态1',
    'common.warnState2': '警告状态2',
    'common.cell': '单体电池',
    'common.avgVoltage': '平均电压',
    'common.avgTemperature': '平均温度',
    'common.totalCurrent': '总电流',
    'common.totalPower': '总功率',
    'common.fullyCharged': '已充满',
    'common.user': '用户',
    'common.deviceId': '设备ID',
    'common.unknownWarning': '未知告警',
    'common.admin': '管理员',
    'common.protection': '保护',
    'common.fault': '故障',
    'common.calibration': '校准',
    'common.refresh': '刷新数据',
    'common.addDevice': '添加设备',
    'common.deviceAdded': '设备添加成功',
    'common.cycleCount': '循环次数',
    'common.soh': 'SOH',
    'common.realtime': '实时监控',
    'common.batteryPackTitle': '电池包 #{{index}}',
    'common.remainCapacityAh': '剩余容量 (Ah)',
    'common.fullChargeCapacityAh': '满充容量 (Ah)',
    'common.designCapacityAh': '设计容量 (Ah)',
    'common.backToDetail': '返回安装详情',
    'common.loadDeviceFailed': '加载设备详情失败',
    'common.permissionsManagement': '权限管理',
    'common.shortCircuitProt': '短路保护',
    'common.startDate': '开始时间',
    'common.endDate': '结束时间',
    // Status & States
    'common.expired': '已过期',
    // Actions
    'common.create': '创建',
    // Time-related
    'common.day': '天',
    'common.days': '天',
    'common.createdAt': '创建时间',
    'common.expiry': '过期时间',
    'common.expiryDays': '有效期（天）',
    // Battery-related
    'common.batteryPack': '电池包',
    'common.dischargeEnabled': '放电使能',
    'common.chargeEnabled': '充电使能',
    'common.currentLimit': '电流限制',
    'common.charger': '充电器',
    'common.type': '类型',
    'common.avg': '平均',


    // 设备
    'device.lastConnection': '最后连接时间',
    'device.delete': '删除安装',
    'device.view': '查看设备',
    'device.notFound': '未找到设备',
    'device.deleteSuccess': '安装删除成功',
    'device.confirmDelete': '您确定要删除此安装吗？',
    'device.info': '安装信息',
    'device.details': '设备详情',
    'device.never': '从未',
    'device.errorMissingFields': '请填写所有必填字段',
    'device.idHelp': '为您的设备输入一个唯一的ID',
    'device.nameHelp': '为您的设备命名',
    'device.loading': '正在加载设备...',
    'common.justNow': '刚刚',
    'device.minutesAgo': '分钟前',
    'device.hoursAgo': '小时前',
    'device.noDevicesDesc': '您尚未添加任何设备。点击下方按钮添加您的第一个设备。',
    'device.deleting': '正在删除...',
    'device.noConnections': '没有最近的连接',
    'device.type': '设备类型',
    'device.optionalInfo': '可选信息',
    'device.optionalInfoTooltip': '填写这些信息可以帮助我们更好地为您提供售后服务和技术支持',
    'device.inverterBrand': '逆变器品牌',
    'device.inverterModel': '逆变器型号',
    'device.solarPower': '太阳能功率 (kW)',
    'device.city': '安装城市',
    'device.description': '安装描述',
    'device.updatedAt': '更新时间',

    // 电池数据
    'battery.status': '充电状态',
    'battery.data': '电池数据',
    'battery.history': '历史记录',
    'battery.protectionRecord': '保护记录',
    'battery.from': '从',
    'battery.to': '到',
    'battery.noData': '无可用数据',
    'battery.historyCharts': '历史图表',
    'battery.resetZoom': '重置',
    'battery.balance': '均衡电流',
    'battery.cells': '单体数量',
    'battery.cellData': '单体电池数据',
    'battery.cellVoltageData': '单体电池电压数据',
    'battery.temperatureData': '温度传感器数据',
    'battery.cellDataUnavailable': '单体电池数据暂不可用，显示之前的数据...',
    'battery.tempDataUnavailable': '温度传感器数据暂不可用，显示之前的数据...',
    'battery.cellVoltageTable': '单体电池数据表',
    'battery.tempDataTable': '温度传感器数据表',
    'battery.cellStats': '单体电池统计',
    'battery.activeBalancing': '主动均衡',
    'battery.activeBalancingOn': '均衡中',
    'battery.heaterEnabled': '加热使能',
    'battery.currentLimitEnabled': '限流使能',
    'battery.highest': '最高',
    'battery.lowest': '最低',
    'battery.highestVoltage': '最高电压',
    'battery.lowestVoltage': '最低电压',
    'battery.volDiff': '电压差',
    'battery.totalCells': '总单体数',
    'battery.temperatureSensors': '温度传感器',
    'battery.temperatureStats': '温度统计',
    'battery.sensorCount': '传感器数量',
    'battery.highestTemperature': '最高温度',
    'battery.lowestTemperature': '最低温度',
    'battery.faultState': '故障状态',
    'battery.protectState1': '保护状态1',
    'battery.protectState2': '保护状态2',

    // 告警标题
    'warning.title': '告警信息',
    'warning.current': '当前告警',
    'warning.normal': '当前电池状态正常，无告警',
    'warning.noWarning': '无告警',

    // 告警状态

    // 保护状态相关
    'warning.protect_high_discharge_current': '放电过流保护',
    'warning.protect_high_charge_current': '充电过流保护',
    'warning.protect_low_total_voltage': '总电压过低保护',
    'warning.protect_high_total_voltage': '总电压过高保护',
    'warning.protect_low_cell_voltage': '单体电压过低保护',
    'warning.protect_high_cell_voltage': '单体电压过高保护',
    'warning.protect_low_env_temp': '环境温度过低保护',
    'warning.protect_high_env_temp': '环境温度过高保护',
    'warning.protect_high_mos_temp': 'MOS温度过高保护',
    'warning.protect_low_discharge_temp': '放电温度过低保护',
    'warning.protect_low_charge_temp': '充电温度过低保护',
    'warning.protect_high_discharge_temp': '放电温度过高保护',
    'warning.protect_high_charge_temp': '充电温度过高保护',

    // 指令状态相关
    'battery.reverse_connected': '电池反接',

    // 故障状态相关
    'warning.fault_sampling': '采样故障',
    'warning.fault_cell': '电池故障',
    'warning.fault_ntc': '温度传感器故障',
    'warning.fault_discharge_mos': '放电MOS故障',
    'warning.fault_charge_mos': '充电MOS故障',
    'warning.fault_adapter_temp': '转接板过温',
    'warning.fault_virtual_connection': '电池虚接',
    'warning.fault_communication': '通信故障',
    'warning.fault_ccb': 'CCB故障',
    'warning.fault_heater': '加热器故障',
    'warning.fault_12v': '12V供电故障',
    'warning.fault_total_voltage': '总电压检测故障',
    'warning.fault_temp_diff': '温差过大',
    'warning.fault_detect_resistor': '检测电阻故障',
    'warning.fault_trip_unit': '跳闸单元故障',
    'warning.fault_master_slave': '主从通信故障',
    'warning.fault_bms_lock': 'BMS锁定',
    'warning.fault_mcu_overvoltage': 'MCU过压',

    'warning.protect_short_circuit': '短路保护',
    'warning.protect_charger_overvoltage': '充电器高压保护',
    'warning.protect_full_charge': '满充保护',

    // 状态指示
    'status.limit_current_on': '限流开启',
    'status.limit_current_off': '限流关闭',
    'status.charge_mos_on': '充电MOS开启',
    'status.charge_mos_off': '充电MOS关闭',
    'status.discharge_mos_on': '放电MOS开启',
    'status.discharge_mos_off': '放电MOS关闭',
    'status.charger_connected': '充电器接入',
    'status.charger_disconnected': '充电器未接入',
    'status.heater_on': '加热开启',
    'status.heater_off': '加热关闭',

    // 告警状态1相关
    'warning.warn_high_discharge_current': '放电电流过大告警',
    'warning.warn_high_charge_current': '充电电流过大告警',
    'warning.warn_low_total_voltage': '总电压过低告警',
    'warning.warn_high_total_voltage': '总电压过高告警',
    'warning.warn_low_cell_voltage': '单体电压过低告警',
    'warning.warn_high_cell_voltage': '单体电压过高告警',

    // 告警状态2相关
    'warning.warn_low_soc': '电量过低告警',
    'warning.warn_high_mos_temp': 'MOS温度过高告警',
    'warning.warn_low_env_temp': '环境温度过低告警',
    'warning.warn_high_env_temp': '环境温度过高告警',
    'warning.warn_low_discharge_temp': '放电温度过低告警',
    'warning.warn_low_charge_temp': '充电温度过低告警',
    'warning.warn_high_discharge_temp': '放电温度过高告警',
    'warning.warn_high_charge_temp': '充电温度过高告警',

    // 告警状态
    'warning.below_lower_limit': '低于下限',
    'warning.above_upper_limit': '高于上限',
    'warning.user_defined': '用户自定义告警',
    'warning.other_fault': '其他故障',

    // 告警描述（用于tooltip）
    'warningDesc.warn_low_soc': '电池电量低于安全阈值，请及时充电',
    'warningDesc.warn_high_mos_temp': 'MOS管温度过高，可能影响充放电效率',
    'warningDesc.warn_low_env_temp': '环境温度过低，可能影响电池性能',
    'warningDesc.warn_high_env_temp': '环境温度过高，请注意散热',
    'warningDesc.warn_low_discharge_temp': '放电温度过低，已限制放电',
    'warningDesc.warn_low_charge_temp': '充电温度过低，已限制充电',
    'warningDesc.warn_high_discharge_temp': '放电温度过高，已限制放电',
    'warningDesc.warn_high_charge_temp': '充电温度过高，已限制充电',
    'warningDesc.warn_high_discharge_current': '放电电流超过安全限值',
    'warningDesc.warn_high_charge_current': '充电电流超过安全限值',
    'warningDesc.warn_low_total_voltage': '总电压低于安全阈值',
    'warningDesc.warn_high_total_voltage': '总电压高于安全阈值',
    'warningDesc.warn_low_cell_voltage': '单体电池电压过低',
    'warningDesc.warn_high_cell_voltage': '单体电池电压过高',
    'warningDesc.protect_high_discharge_current': '放电电流过大，已触发保护',
    'warningDesc.protect_high_charge_current': '充电电流过大，已触发保护',
    'warningDesc.protect_short_circuit': '检测到短路，已触发保护',
    'warningDesc.protect_low_total_voltage': '总电压过低，已触发保护',
    'warningDesc.protect_high_total_voltage': '总电压过高，已触发保护',
    'warningDesc.protect_low_cell_voltage': '单体电压过低，已触发保护',
    'warningDesc.protect_high_cell_voltage': '单体电压过高，已触发保护',
    'warningDesc.protect_low_env_temp': '环境温度过低，已触发保护',
    'warningDesc.protect_high_env_temp': '环境温度过高，已触发保护',
    'warningDesc.protect_high_mos_temp': 'MOS温度过高，已触发保护',
    'warningDesc.protect_low_discharge_temp': '放电温度过低，已触发保护',
    'warningDesc.protect_low_charge_temp': '充电温度过低，已触发保护',
    'warningDesc.protect_high_discharge_temp': '放电温度过高，已触发保护',
    'warningDesc.protect_high_charge_temp': '充电温度过高，已触发保护',
    'warningDesc.fault_sampling': '电池采样电路异常，请检查硬件',
    'warningDesc.fault_cell': '电池单体故障，请检查电池组',
    'warningDesc.fault_ntc': '温度传感器故障，无法准确测量温度',
    'warningDesc.fault_discharge_mos': '放电MOS管故障，无法正常放电',
    'warningDesc.fault_charge_mos': '充电MOS管故障，无法正常充电',
    'warningDesc.fault_adapter_temp': '转接板温度过高',
    'warningDesc.fault_virtual_connection': '电池接触不良，请检查连接',

    // 充电状态常量

    // 认证
    'auth.loginTitle': '登录您的账户',
    'auth.registerTitle': '创建新账户',
    'auth.forgotPassword': '忘记密码？',
    'auth.noAccount': '没有账户？',
    'auth.haveAccount': '已有账户？',
    'auth.loginSuccess': '登录成功',
    'auth.registerSuccess': '注册成功',
    'auth.registerFailed': '注册失败',
    'auth.logoutSuccess': '退出登录成功',
    'auth.invalidCredentials': '无效的邮箱或密码',
    'auth.passwordMismatch': '密码不匹配',
    'auth.emailExists': '邮箱已存在',
    'auth.usernameExists': '用户名已存在',
    'auth.managerEmail': '管理员邮箱（可选）',
    'auth.managerEmailHelp': '如果您知道您的管理员的邮箱，请在此处输入以添加到他们的团队',
    'auth.invitationCode': '邀请码（可选）',
    'auth.invitationCodeHelp': '如果您有邀请码，请在此处输入',
    'auth.forgotPasswordDesc': '请输入您的注册邮箱，我们将向您发送重置密码的链接。',
    'auth.forgotPasswordSuccess': '重置邮件已发送，请检查您的收件箱。',
    'auth.invalidToken': '无效的令牌',
    'auth.tokenErrorDesc': '无效或缺失的重置令牌。请从您的电子邮件链接中访问此页面。',
    'auth.passwordUpdated': '密码已成功重置，将跳转到登录页面。',
    'auth.resetPasswordTitle': '重置密码',

    // 设置
    'settings.about': '关于',
    'settings.aboutDesc': '家用电池物联网是一个家用电池设备监控系统。',
    'settings.languageUpdated': '语言更新成功',
    'settings.updateFailed': '设置更新失败',
    'settings.changePassword': '修改密码',
    'settings.currentPassword': '当前密码',
    'settings.newPassword': '新密码',
    'settings.confirmPassword': '确认新密码',
    'settings.passwordUpdated': '密码修改成功',
    'settings.passwordMismatch': '两次输入的密码不一致',
    'settings.passwordTooShort': '密码至少需要6个字符',
    'settings.usernameUpdated': '用户名更新成功',
    'settings.appearance': '外观设置',
    'settings.avatar': '头像',
    'settings.changeAvatar': '更换头像',
    'settings.avatarHint': '最大2MB，支持JPG/PNG/GIF/WebP格式',
    'settings.avatarUpdated': '头像更新成功',
    'settings.invalidFileType': '请选择图片文件',
    'settings.fileTooLarge': '文件过大，最大支持2MB',
    'settings.timezone': '时区',
    'settings.timezoneUpdated': '时区更新成功',

    // Timezone labels
    'timezones.UTC': 'UTC (协调世界时)',
    'timezones.Europe/London': '伦敦 (GMT/BST)',
    'timezones.Europe/Dublin': '都柏林 (GMT/IST)',
    'timezones.Europe/Paris': '巴黎 (CET/CEST)',
    'timezones.Europe/Berlin': '柏林 (CET/CEST)',
    'timezones.Europe/Amsterdam': '阿姆斯特丹 (CET/CEST)',
    'timezones.Europe/Brussels': '布鲁塞尔 (CET/CEST)',
    'timezones.Europe/Rome': '罗马 (CET/CEST)',
    'timezones.Europe/Madrid': '马德里 (CET/CEST)',
    'timezones.Europe/Lisbon': '里斯本 (WET/WEST)',
    'timezones.Europe/Vienna': '维也纳 (CET/CEST)',
    'timezones.Europe/Zurich': '苏黎世 (CET/CEST)',
    'timezones.Europe/Stockholm': '斯德哥尔摩 (CET/CEST)',
    'timezones.Europe/Oslo': '奥斯陆 (CET/CEST)',
    'timezones.Europe/Copenhagen': '哥本哈根 (CET/CEST)',
    'timezones.Europe/Helsinki': '赫尔辛基 (EET/EEST)',
    'timezones.Europe/Warsaw': '华沙 (CET/CEST)',
    'timezones.Europe/Prague': '布拉格 (CET/CEST)',
    'timezones.Europe/Athens': '雅典 (EET/EEST)',
    'timezones.Europe/Istanbul': '伊斯坦布尔 (TRT)',
    'timezones.Europe/Moscow': '莫斯科 (MSK)',
    'timezones.America/New_York': '纽约 (EST/EDT)',
    'timezones.America/Toronto': '多伦多 (EST/EDT)',
    'timezones.America/Chicago': '芝加哥 (CST/CDT)',
    'timezones.America/Denver': '丹佛 (MST/MDT)',
    'timezones.America/Phoenix': '凤凰城 (MST)',
    'timezones.America/Los_Angeles': '洛杉矶 (PST/PDT)',
    'timezones.America/Vancouver': '温哥华 (PST/PDT)',
    'timezones.America/Anchorage': '安克雷奇 (AKST/AKDT)',
    'timezones.Pacific/Honolulu': '檀香山 (HST)',
    'timezones.America/Mexico_City': '墨西哥城 (CST/CDT)',
    'timezones.America/Bogota': '波哥大 (COT)',
    'timezones.America/Lima': '利马 (PET)',
    'timezones.America/Santiago': '圣地亚哥 (CLT/CLST)',
    'timezones.America/Sao_Paulo': '圣保罗 (BRT)',
    'timezones.America/Buenos_Aires': '布宜诺斯艾利斯 (ART)',
    // Middle East
    'timezones.Asia/Jerusalem': '耶路撒冷 (IST)',
    'timezones.Asia/Beirut': '贝鲁特 (EET/EEST)',
    'timezones.Asia/Amman': '安曼 (EET/EEST)',
    'timezones.Asia/Baghdad': '巴格达 (AST)',
    'timezones.Asia/Kuwait': '科威特 (AST)',
    'timezones.Asia/Dubai': '迪拜 (GST)',
    'timezones.Asia/Muscat': '马斯喀特 (GST)',
    'timezones.Asia/Riyadh': '利雅得 (AST)',
    'timezones.Asia/Qatar': '多哈 (AST)',
    'timezones.Asia/Bahrain': '巴林 (AST)',
    'timezones.Asia/Tehran': '德黑兰 (IRST)',
    // Central Asia
    'timezones.Asia/Kabul': '喀布尔 (AFT)',
    'timezones.Asia/Karachi': '卡拉奇 (PKT)',
    'timezones.Asia/Tashkent': '塔什干 (UZT)',
    'timezones.Asia/Almaty': '阿拉木图 (ALMT)',
    // South Asia
    'timezones.Asia/Kolkata': '孟买 / 新德里 (IST)',
    'timezones.Asia/Colombo': '科伦坡 (IST)',
    'timezones.Asia/Kathmandu': '加德满都 (NPT)',
    'timezones.Asia/Dhaka': '达卡 (BST)',
    'timezones.Asia/Yangon': '仰光 (MMT)',
    // Southeast Asia
    'timezones.Asia/Bangkok': '曼谷 (ICT)',
    'timezones.Asia/Ho_Chi_Minh': '胡志明市 (ICT)',
    'timezones.Asia/Jakarta': '雅加达 (WIB)',
    'timezones.Asia/Singapore': '新加坡 (SGT)',
    'timezones.Asia/Kuala_Lumpur': '吉隆坡 (MYT)',
    'timezones.Asia/Manila': '马尼拉 (PHT)',
    // East Asia
    'timezones.Asia/Hong_Kong': '香港 (HKT)',
    'timezones.Asia/Shanghai': '上海 / 北京 (CST)',
    'timezones.Asia/Taipei': '台北 (CST)',
    'timezones.Asia/Seoul': '首尔 (KST)',
    'timezones.Asia/Tokyo': '东京 (JST)',
    // Oceania
    'timezones.Australia/Perth': '珀斯 (AWST)',
    'timezones.Australia/Adelaide': '阿德莱德 (ACST/ACDT)',
    'timezones.Australia/Brisbane': '布里斯班 (AEST)',
    'timezones.Australia/Sydney': '悉尼 (AEST/AEDT)',
    'timezones.Australia/Melbourne': '墨尔本 (AEST/AEDT)',
    'timezones.Pacific/Auckland': '奥克兰 (NZST/NZDT)',
    // Africa (North)
    'timezones.Africa/Casablanca': '卡萨布兰卡 (WET/WEST)',
    'timezones.Africa/Algiers': '阿尔及尔 (CET)',
    'timezones.Africa/Tunis': '突尼斯 (CET)',
    'timezones.Africa/Tripoli': '的黎波里 (EET)',
    'timezones.Africa/Cairo': '开罗 (EET)',
    // Africa (East)
    'timezones.Africa/Khartoum': '喀土穆 (CAT)',
    'timezones.Africa/Addis_Ababa': '亚的斯亚贝巴 (EAT)',
    'timezones.Africa/Nairobi': '内罗毕 (EAT)',
    // Africa (West)
    'timezones.Africa/Lagos': '拉各斯 (WAT)',
    'timezones.Africa/Accra': '阿克拉 (GMT)',
    // Africa (South)
    'timezones.Africa/Johannesburg': '约翰内斯堡 (SAST)',
    'timezones.Africa/Cape_Town': '开普敦 (SAST)',

    'common.uploading': '上传中...',

    // 错误
    'error.pageNotFound': '页面未找到',
    'error.pageNotFoundDesc': '您查找的页面可能已被删除、更名或暂时不可用。',
    'error.fetchFailed': '获取数据失败',
    'error.createFailed': '创建失败',
    'error.copyFailed': '复制失败',
    'error.processFailed': '处理请求失败',

    // 管理员
    'admin.dashboard': '管理员仪表板',
    'admin.superDashboard': '超级管理员仪表板',
    'admin.managedUsers': '管理的用户',
    'admin.managedDevices': '管理的设备',
    'admin.role': '角色',
    'admin.superadmin': '超级管理员',
    'admin.noUsers': '未找到用户',
    'admin.userList': '用户列表',
    'admin.adminList': '管理员列表',
    'admin.deviceList': '设备列表',
    'admin.noAdmins': '未找到管理员',
    'admin.addAdmin': '添加管理员',
    'admin.createError': '创建管理员错误',
    'admin.fillAllFields': '请填写所有字段',
    'admin.deviceCount': '设备数量',
    'admin.assignManager': '分配管理员',
    'admin.selectManager': '选择管理员',
    'admin.noManager': '无管理员（取消分配）',
    'admin.assigningUser': '分配用户',
    'admin.assign': '分配',
    'admin.assignError': '分配管理员错误',
    'admin.self': '自己',
    'admin.active': '活跃',
    'admin.used': '已使用',
    'admin.adminPanel': '管理员面板',
    'admin.newsManagement': '新闻管理',
    'admin.addNews': '添加新闻',
    'admin.editNews': '编辑新闻',
    'admin.deleteNews': '删除新闻',
    'admin.deleteNewsConfirm': '您确定要删除这篇新闻吗？',
    'admin.newsTitle': '标题',
    'admin.newsSummary': '摘要',
    'admin.newsContent': '内容',
    'admin.newsImageUrl': '图片链接',
    'admin.newsPublished': '已发布',
    'admin.newsDraft': '草稿',
    'admin.newsStatus': '状态',
    'admin.newsCreateSuccess': '新闻创建成功',
    'admin.newsUpdateSuccess': '新闻更新成功',
    'admin.newsDeleteSuccess': '新闻删除成功',

    // 邀请码管理
    'admin.invitationManagement': '邀请码管理',
    'admin.createInvitation': '创建邀请',
    'admin.invitationCode': '邀请码',
    'admin.invitationCreated': '邀请创建成功',
    'admin.copy': '复制',
    'admin.codeCopied': '代码已复制到剪贴板',
    'admin.noInvitations': '未找到邀请',

    // 授权请求相关
    'user.authRequests': '授权请求',
    'user.authRequestManagement': '授权请求管理',
    'user.createAuthRequest': '创建授权请求',
    'user.authCode': '授权码',
    'user.authRequestCreated': '授权请求创建成功',
    'user.shareAuthLink': '分享授权链接',
    'user.shareAuthLinkHelp': '发送此链接给管理员，授权他们管理您的账户',
    'user.linkCopied': '链接已复制到剪贴板',
    'user.copyLink': '复制链接',
    'user.share': '分享',
    'user.shareLink': '分享链接',
    'user.authRequestHelp': '创建授权请求，允许管理员管理您的账户',
    'user.authRequestShareTitle': '物联网电池管理授权',
    'user.authRequestShareText': '请授权您作为我的电池系统管理员',
    'common.noAuthRequests': '未找到授权请求',
    'user.pending': '待处理',
    'user.accepted': '已接受',
    'user.rejected': '已拒绝',

    'admin.authRequestReview': '授权请求审核',
    'admin.authRequestDetails': '授权请求详情',
    'admin.authRequestLoadError': '加载授权请求失败',
    'admin.requestCode': '请求码',
    'admin.createdBy': '创建者',
    'admin.processedBy': '处理者',
    'admin.processedAt': '处理时间',
    'admin.unknownUser': '未知用户',
    'admin.accept': '接受',
    'admin.reject': '拒绝',
    'admin.authRequestAccepted': '授权请求接受成功',
    'admin.authRequestRejected': '授权请求拒绝成功',
    'admin.authRequestNotForAdmin': '授权请求管理仅适用于普通用户。作为管理员，您可以审核和处理来自用户的授权请求。',

    // 电池包详情
    'battery.packageDetails': '电池包详情',

    'battery.basicInfo': '基本信息',
    'battery.cellCount': '单体电池数量',
    'battery.tempSensorCount': '温度传感器数量',
    'battery.chargeCurrentStatus': '充电电流状态',
    'battery.totalVoltageStatus': '总电压状态',
    'battery.dischargeCurrentStatus': '放电电流状态',
    'battery.controlStatus': '控制与指令状态',
    'battery.instructionState': '指令状态',
    'battery.controlState': '控制状态',
    'battery.chargerAvailable': '充电器可用',
    'battery.warningStatus': '警告与故障状态',
    'battery.led_warning': 'LED警告',
    'battery.buzzer_warning': '蜂鸣器警告',
    'battery.freq_shift': '频率偏移',
    'battery.parallelStatus': '并联电池系统状态',
    'battery.parallelCount': '并联电池数量',
    'battery.avgCycleCount': '平均循环次数',
    'battery.cycleCountUnit': '次',


    'battery.standby': '待机',
    'battery.cellVoltage': '单体电压',
    'battery.batteryPackUnavailable': '电池包数据暂不可用，尝试显示上次数据...',
    'battery.normalStatus': '该电池包状态正常，无告警或故障',
    'battery.warn_high_charge_temp': '充电温度过高',

    // 仪表盘新增内容
    'dashboard.soc': '电量(SOC)',
    'dashboard.voltage': '总电压',
    'dashboard.current': '总电流',
    'dashboard.temperature': '最高温度',
    'dashboard.systemStatus': '系统状态',
    'dashboard.totalDevices': '总设备数',
    'dashboard.onlineDevices': '在线设备',
    'dashboard.deviceStatus': '设备状态',
    'dashboard.batteryStatus': '电池状态',
    'dashboard.powerStatus': '功率状态',
    'dashboard.temperatureStatus': '温度状态',
    'dashboard.avgSOC': '平均电量',
    'dashboard.types': '类型',
    'dashboard.batteryHistory': '电池历史数据',
    'dashboard.voltageHistory': '电压历史',
    'dashboard.currentHistory': '电流历史',
    'dashboard.socHistory': '电量历史',
    'dashboard.temperatureHistory': '温度历史',
    'dashboard.lastHour': '最近1小时',
    'dashboard.last6Hours': '最近6小时',
    'dashboard.lastDay': '最近24小时',
    'dashboard.lastWeek': '最近一周',
    'dashboard.lastMonth': '最近一月',
    'dashboard.batteryDetails': '电池详情',
    'dashboard.deviceAnalysis': '设备分析',
    'dashboard.systemOverview': '系统概览',
    'dashboard.deviceTypeDistribution': '设备类型分布',
    'dashboard.voltageAndCurrentOverview': '电压和电流概览',
    'dashboard.onlinePercentage': '在线比例',
    'dashboard.noAlerts': '暂无告警记录',

    // Dashboard页面专用
    'dashboard.totalInstallations': '总安装数',
    'dashboard.viewAllInstallations': '查看所有安装',
    'dashboard.activeInstallations': '活跃安装',
    'dashboard.allInstallations': '所有安装',
    'dashboard.systemAlertsNotices': '系统警报和通知',
    'dashboard.deviceOffline': '设备离线',
    'dashboard.deviceOfflineDesc': '设备 {{name}} ({{id}}) 当前离线。请检查连接。',
    'dashboard.deviceAlarm': '设备告警',
    'dashboard.deviceAlarmDesc': '设备 {{name}} ({{id}}) 有活跃告警。请检查设备状态。',
    'dashboard.systemNormal': '系统正常',
    'dashboard.systemNormalDesc': '所有系统运行正常。',
    'dashboard.latestNews': '产品新闻',

    // InstallationList页面
    'installations.loadError': '加载安装失败。请稍后再试。',
    'installations.noInstallations': '未找到安装。',
    'installations.realtime': '实时',
    'installations.oldData': '历史数据',
    'installations.batteries': '电池数',
    'installations.lastUpdate': '最后更新',
    'installations.deviceName': '安装名称（可选）',
    'installations.deviceNamePlaceholder': '我的电池系统',
    'installations.deviceNameHelper': '为您的设备起一个友好的名称',
    'installations.deviceIdRequired': '设备ID为必填项',
    'installations.deviceIdPlaceholder': '见WIFI设备标签',
    'installations.deviceClaimed': '设备认领成功',
    'installations.addFailed': '添加设备失败',
    'installations.otherType': '其他',


    // Installation Detail页面
    'detail.backToList': '返回列表',
    'detail.installationDetail': '安装详情',
    'detail.installationName': '安装名称',
    'detail.owner': '所有者',
    'detail.batteryCount': '电池数量',
    'detail.realtimeMetrics': '实时指标',
    'detail.avgSOC': '平均SOC',
    'detail.avgSOH': '平均SOH',
    'detail.maxCellVol': '最高单体电压',
    'detail.minCellVol': '最低单体电压',
    'detail.cellVolDiff': '单体压差',

    // Battery Detail页面
    'battery.packDetail': '电池包 #{{index}} 详情',

    'battery.packNotFound': '未找到电池包数据',
    'battery.loadError': '加载电池数据失败',

    // Battery Overview
    'battery.packVoltage': '电池包电压',
    'battery.packCurrent': '电池包电流',
    'battery.packPower': '电池包功率',
    'battery.chargerConnected': '充电器已连接',
    'battery.fullEnergy': '满电能量',
    'battery.remainEnergy': '剩余能量',

    'common.yes': '是',
    'common.no': '否',
    'common.on': '开启',
    'common.off': '关闭',
    'common.ongoing': '进行中',


    // RealTime Monitor
    'battery.cellVoltages': '电芯电压',
    'battery.temperatures': '温度监控',

    // History Charts
    'battery.historyTrends': '历史趋势',
    'battery.voltageCurrent': '电压 & 电流',

    'battery.dragToSelect': '拖动选择时间范围',

    'battery.alarmDetails': '告警详情',
    'battery.noActiveAlarms': '当前无活动告警',
    'battery.sensor': '传感器',
    'battery.issue': '问题',
    'battery.tempSensorIssues': '温度传感器问题',

    // Charts & Widgets
    'battery.minCellVoltage': '最小电芯电压',
    'battery.maxCellVoltage': '最大电芯电压',


    'battery.mosTemp': 'MOS温度',
    'battery.envTemp': '环境温度',
    'battery.otherTemps': '其他温度',


    'battery.noDataAvailable': '暂无数据',
    'battery.fetchError': '获取历史数据失败',
    'battery.generalError': '发生错误',
    'settings.jkReadOnlyNote': '极空 BMS 设置由广播自动更新，在本系统中为只读模式。',
    'settings.lastUpdated': '最后更新',

    // Settings - Common
    'settings.recover': '恢复',
    'settings.delay': '延时',
    'settings.unitV': '单位: V',
    'settings.unitA': '单位: A',
    'settings.unitMs': '单位: ms',
    'settings.unitUs': '单位: μs',
    'settings.unitC': '单位: °C',
    'settings.charge': '充电',
    'settings.discharge': '放电',
    'settings.high': '高',
    'settings.low': '低',
    'settings.description': '说明',
    'settings.read': '读取',
    'settings.setting': '正在设置...',
    'settings.readSuccess': '读取成功',
    'settings.timeout': '操作超时',
    'settings.operationFailed': '操作失败',
    'settings.failed': '失败',

    // Settings - Control Tab
    'settings.mosControl': 'MOS 控制',
    'settings.chargeMosControl': '充电MOS控制',
    'settings.openChargeMos': '开启充电MOS',
    'settings.closeChargeMos': '关闭充电MOS',
    'settings.dischargeMosControl': '放电MOS控制',
    'settings.openDischargeMos': '开启放电MOS',
    'settings.closeDischargeMos': '关闭放电MOS',
    'settings.powerManagement': '电源管理',
    'settings.shutdownSleep': '关机/休眠',
    'settings.opening': '正在开启...',
    'settings.closing': '正在关闭...',
    'settings.executing': '正在执行...',

    // Settings - Protection Tab
    'settings.protGroup1': '电压保护参数',
    'settings.cellOvercharge': '单体过充',
    'settings.cellOverchargeDesc': '当单体电压持续超过保护值达到设定延时后，BMS会立即执行保护动作，强制停止充电。触发保护后，当所有单体电压都回落至恢复值以下，系统恢复充电功能。',
    'settings.cellOverdischarge': '单体过放',
    'settings.cellOverdischargeDesc': '当单体电压持续低于保护值达到设定延时后，BMS会立即执行保护动作，强制停止放电。触发保护后，当所有单体电压都回升至恢复值以上，系统恢复放电功能。',
    'settings.totalOvercharge': '整组过充',
    'settings.totalOverchargeDesc': '当整组电压持续超过保护值达到设定延时后，BMS会立即执行保护动作，强制停止充电。触发保护后，当所有单体电压都回落至恢复值以下，系统恢复充电功能。',
    'settings.totalOverdischarge': '整组过放',
    'settings.totalOverdischargeDesc': '当整组电压持续低于保护值达到设定延时后，BMS会立即执行保护动作，强制停止放电。触发保护后，当所有单体电压都回升至恢复值以上，系统恢复放电功能。',

    'settings.protGroup2': '电流保护参数',
    'settings.chargeOvercurrent': '充电过流',
    'settings.chargeOvercurrentDesc': '警告值为电池向逆变器请求的最大充电电流。当充电电流持续超过保护值达到设定延时后，BMS会立即执行保护动作，强制停止充电。',
    'settings.dischargeOvercurrent1': '放电过流 1',
    'settings.dischargeOvercurrent1Desc': '警告值为电池向逆变器请求的最大放电电流。当放电电流持续超过保护值达到设定延时后，BMS会立即执行保护动作，强制停止放电。',
    'settings.dischargeOvercurrent2': '放电过流 2',
    'settings.dischargeOvercurrent2Desc': '当放电电流持续超过保护值达到设定延时后，BMS会立即执行保护动作，强制停止放电。',
    'settings.maxChargeCurrent': '充电电流限制',
    'settings.maxChargeCurrentDesc': '充电电流限制值（CCL，Charge Current Limit）是指单个电池模块在正常运行状态下向逆变器上报的允许最大充电电流。当系统中有 N 个电池模块并联运行时，电池系统向逆变器请求的总最大充电电流为各模块 CCL 的叠加，即 CCL × N。\n保护值是指单个电池模块触发过流保护动作的阈值。充电电流限制值 CCL 必须小于保护值。',
    'settings.maxDischargeCurrent': '放电电流限制',
    'settings.maxDischargeCurrentDesc': '放电电流限制值（DCL，Discharge Current Limit）是指单个电池模块在正常运行状态下向逆变器上报的允许最大放电电流。当系统中有 N 个电池模块并联运行时，电池系统向逆变器请求的总最大放电电流为各模块 DCL 的叠加，即 DCL × N。\n保护值是指单个电池模块触发过流保护动作的阈值。放电电流限制值 DCL 必须小于保护值。',
    'settings.maxChargeVoltage': '充电电压限制',
    'settings.maxChargeVoltageDesc': '充电电压限制值（CVL，Charge Voltage Limit）是指电池系统向逆变器请求的总允许最大充电电压。',
    'settings.chargeVoltageLimitV': '充电电压限制 (V)',
    'settings.chargeCurrentLimitA': '充电电流限制 (A)',
    'settings.dischargeCurrentLimitA': '放电电流限制 (A)',
    'settings.shortCircuitDesc': '当短路达到设定延时后，BMS会立即执行保护动作，强制停止充电和放电。',

    'settings.protGroup3': '温度保护参数',
    'settings.tempHigh': '高温保护',
    'settings.tempHighDesc': '当温度超过保护值后，BMS会立即执行保护动作，强制停止充电或放电。触发保护后，当温度回落至恢复值以下，系统恢复充电或放电功能。',
    'settings.tempLow': '低温保护',
    'settings.tempLowDesc': '当温度低于保护值后，BMS会立即执行保护动作，强制停止充电或放电。触发保护后，当温度回升至恢复值以上，系统恢复充电或放电功能。当温度低于充电警告值后，加热功能自动开启，当温度回升至充电恢复值后，加热功能自动关闭。',
    'settings.mosTempHigh': 'MOS 高温保护',
    'settings.mosTempHighDesc': '当MOS温度高于保护值后，BMS立即执行保护动作，强制停止充电和放电。触发保护后，当MOS温度回落至恢复值以下，系统恢复充电或放电功能。',
    'settings.envTemp': '环境温度保护',
    'settings.envTempDesc': '当环境温度超过高温保护值或低于低温保护值时，BMS 会立即执行保护动作，强制停止充电或放电。触发保护后，当环境温度恢复至对应的恢复温度范围内，系统将自动恢复充电或放电功能。',

    'settings.enableProtection': '启用保护',
    'settings.chargeTempProt': '充电温度保护',
    'settings.dischargeTempProt': '放电温度保护',
    'settings.chargeHighTemp': '充电高温',
    'settings.chargeHighTempRecovery': '充电高温恢复',
    'settings.dischargeHighTemp': '放电高温',
    'settings.dischargeHighTempRecovery': '放电高温恢复',
    'settings.balanceStartVoltage': '均衡启动电压',
    'settings.balanceTriggerDiff': '均衡触发压差',
    'settings.balanceMaxCurrent': '最大均衡电流',
    'settings.designCapacity': '设计容量',

    // JK BMS 设置块标题和字段
    'settings.temperatureHighProtection': '高温保护',
    'settings.temperatureLowProtection': '低温保护',
    'settings.mosTempHighProtection': 'MOS 高温保护',
    'settings.balanceParams': '均衡参数',
    'settings.protection': '保护',
    'settings.chargeLowTemp': '充电低温',
    'settings.dischargeLowTemp': '放电低温',

    'common.enabled': '已启用',

    // JK BMS 设置 - 整组电压保护
    'jk.noSettingsData': '尚未收到设置数据。BMS广播SETUP帧时会自动更新设置。',
    'jk.chargeVoltages': '充电电压',
    'jk.socSettings': 'SOC设置',
    'jk.packVoltageProtection': '整组电压保护',
    'jk.packOVP': '浮充电压',
    'jk.packUVP': '逆变器最大充电电压',
    'jk.floatVoltage': '浮充电压',
    'jk.inverterMaxChargeVoltage': '逆变器最大充电电压',
    'jk.soc100Voltage': 'SOC 100%电压',
    'jk.soc0Voltage': 'SOC 0%电压',
    'jk.smartSleepVoltage': '智能休眠电压',
    'jk.autoPowerOffVoltage': '自动关机电压',
    // JK BMS 设置 - 电流保护
    'jk.currentProtection': '电流保护',
    'jk.chargeOC': '持续充电电流',
    'jk.chargeOCPDelay': '充电过流保护延迟',
    'jk.chargeOCPRelease': '充电过流保护解除',
    'jk.dischargeOC': '持续放电电流',
    'jk.dischargeOCPDelay': '放电过流保护延迟',
    'jk.dischargeOCPRelease': '放电过流保护解除',
    'jk.scpRelease': '短路保护解除延迟',
    // JK BMS 设置 - 电池配置
    'jk.batteryConfig': '电池配置',
    'jk.cellCount': '电芯串数',
    'jk.chargeSwitch': '充电开关',
    'jk.dischargeSwitch': '放电开关',
    'jk.balanceSwitch': '均衡开关',
    'jk.scpDelay': '短路保护延时',
    // JK BMS 设置 - 设备配置
    'jk.deviceConfig': '设备配置',
    'jk.deviceAddress': '设备地址',
    'jk.prechargeDelay': '预充延时',
    'jk.smartSleepTime': '智能休眠时间',
    'jk.heatEnabled': '加热功能',
    'jk.tempSensorDisabled': '温度传感器禁用',
    'jk.gpsHeartbeat': 'GPS心跳',
    'jk.portSwitch': '通讯端口 (RS485)',
    'jk.lcdAlwaysOn': '屏幕常亮',
    'jk.specialCharger': '专用充电器',
    'jk.smartSleepEnabled': '智能休眠',
    'jk.disablePCLModule': '禁用并联限流',
    'jk.timedStoredData': '定时数据存储',
    'jk.chargingFloatMode': '充电浮充模式',

    // Settings - History Tab
    'settings.historyManagement': '历史记录管理',
    'settings.reading': '正在读取...',
    'settings.readHistory': '读取所有历史记录(1-40条)',
    'settings.stopReading': '停止读取',
    'settings.clearHistory': '清除历史记录',
    'settings.messages.historyReadComplete': '历史记录读取完成！共读取 {{count}} 条记录',
    'settings.historyRecords': '历史记录 ({{count}} 条记录)',
    'settings.record': '记录 {{index}}',
    'settings.timeUnknown': '时间未知',
    'settings.cellInfo': '电芯信息 ({{count}} 串)',
    'settings.tempSensors': '温度传感器 ({{count}} 个)',
    'settings.statusInfo': '状态信息',
    'settings.noHistoryFound': '未找到历史记录',
    'settings.clearHistoryResult': '清除历史记录结果',
    'settings.confirmClearHistory': '确认清除历史记录',
    'settings.confirmClearHistoryDesc': '确定要从BMS删除所有历史记录吗？',
    'settings.clearHistoryWarning': '此操作将从BMS设备中永久删除所有历史记录数据，且无法恢复。',
    'settings.confirmDelete': '确认删除',

    // Settings - Protocol Tab
    'settings.inverterProtocolConfig': '逆变器协议配置',
    'settings.protocolSelectDesc': '读取逆变器协议列表后，从下拉列表中选择所使用的逆变器协议。',



    'settings.canProtocol': 'CAN 协议',
    'settings.rs485Protocol': 'RS485 协议',
    'settings.selectCanProtocol': '选择 CAN 协议',
    'settings.selectRs485Protocol': '选择 RS485 协议',

    // Settings - System Tab
    'settings.mainBatterySettings': '主电池设置',
    'settings.systemConfig': '电池配置',
    'settings.otherConfig': '其他设置',
    'settings.timeSettings': '时间设置',
    'settings.timeSettingsDesc': 'BMS内部时间，用于显示和记录数据。与本地时间同步可更容易追踪数据。',
    'settings.syncTime': '同步本地时间',
    'settings.bmsTime': 'BMS 时间',
    'settings.capacitySettings': '容量设置',
    'settings.capacitySettingsDesc': '修改剩余容量设置会影响 SOC 百分比显示。设计容量为电池出厂标称容量，满充容量表示当前电池的实际容量，该数值会随着使用时间和循环次数增加而降低。',
    'settings.batterySeries': '串数设置',
    'settings.batterySeriesDesc': '系统默认电芯串数为 16 串；当实际电芯串数少于 16 串时，需要在此处调整为对应的实际值。',
    'settings.batterySeriesHelper': '串联电芯数量',
    'settings.cycleCount': '循环次数设置',
    'settings.cycleCountDesc': '循环次数随电池充放电过程自动累积，并支持在此处进行手动调整。',
    'settings.cycleCountHelper': '电池充放电循环次数',
    'settings.fullChargeParams': '满充参数',
    'settings.fullChargeParamsDesc': '设置满充判定条件。当电池电压和电流同时满足截止条件时，BMS判定电池为满充状态。低容量告警用于设置SOC低电量提示阈值。',
    'settings.fullChargeCutoffVoltage': '满充截止电压 (V)',
    'settings.fullChargeCutoffCurrent': '满充截止电流 (A)',
    'settings.lowCapacityAlarm': '低容量告警 (%)',
    'settings.capacityRelease': '容量释放设置',
    'settings.capacityReleaseDesc': '设置命令 (Set): A5\n设置容量释放的 SOC 阈值。',
    'settings.socValue': 'SOC值 (%)',
    'settings.socRange': '范围: 74-97',
    'settings.currentZero': '电流零点校准',
    'settings.currentZeroDesc': '命令: AA\n在无电流状态下校准电流传感器零点。可输入修正值(默认为0)。',
    'settings.correctionValue': '修正值 (0.1A)',
    'settings.refVoltage': '参考电压校准',
    'settings.refVoltageDesc': '命令: A9\n校准电池组参考电压(通常指电芯电压采样参考)。输入测量到的实际电压值(mV)。',
    'settings.actualVoltageMv': '实际电压 (mV)',
    'settings.totalVoltage': '总电压校准',
    'settings.totalVoltageDesc': '将万用表等测量设备测得的电池实际电压输入此处，可用于校准 BMS 显示的电压值。',
    'settings.actualTotalVoltageMv': '实际总电压 (mV)',
    'settings.chargeCurrent': '充电电流校准',
    'settings.chargeCurrentDesc': '命令: AC\n校准充电电流。输入实际测量的充电电流值(A)。系统会自动转换为0.1A单位。',
    'settings.actualCurrentA': '实际电流 (A)',
    'settings.dischargeCurrent': '放电电流校准',
    'settings.dischargeCurrentDesc': '命令: AB\n校准放电电流。输入实际测量的放电电流值(A)。系统会自动转换为0.1A单位。',
    'settings.systemInfo': '系统信息',
    'settings.versionInfo': '版本信息',
    'settings.versionInfoDesc': 'BMS固件版本。',
    'settings.internalVersion': '固件版本',
    'settings.internalVersionHelper': '内部版本信息',
    'settings.restoreDefault': '恢复默认',
    'settings.restoreDefaultDesc': '此操作将把所有参数恢复为 BMS 出厂设置值。',
    'settings.restoreDefaultBtn': '恢复默认参数',
    'settings.restoring': '正在恢复...',

    // Settings - Permissions Tab
    'settings.permissionsDesc': '授予其他用户查看或控制此安装的权限。',
    'settings.shareSuccess': '成功分享给 {{email}}',
    'settings.shareFailed': '分享安装失败',
    'settings.removeAccessSuccess': '权限移除成功',
    'settings.removeAccessFailed': '移除权限失败',
    'settings.loadingUsers': '加载用户中...',
    'settings.noSharedUsers': '尚未授权给任何用户。',
    'settings.noPermission': '您没有权限管理此安装。只有所有者可以分享安装。',
    'settings.userEmail': '用户邮箱',
    'settings.accessLevel': '访问级别',
    'settings.readOnly': '只读',
    'settings.readWrite': '读写',
    'settings.sharing': '正在分享...',
    'settings.shareDevice': '分享安装',
    'settings.usersWithAccess': '有访问权限的用户',
    'settings.remove': '移除',

    // Settings - SettingsLogTab
    'settings.modificationLog': '设置修改日志',
    'settings.loadHistoryFailed': '加载历史记录失败',
    'settings.noChangesFound': '未发现变更',
    'settings.logSetting': '设置项',
    'settings.na': 'N/A',

    // Settings - Params Mapping (Log Types)
    'settings.enabled': '已启用',
    'settings.controlMode': '控制模式',
    'settings.delayMs': '延时 (ms)',
    'settings.unknown': '未知',
    'settings.alarmVoltage': '警告 (mV)',
    'settings.chargeAlarmVoltage': '充电警告 (mV)',
    'settings.dischargeAlarmVoltage': '放电警告 (mV)',
    'settings.protectionVoltage': '保护 (mV)',
    'settings.recoveryVoltage': '恢复 (mV)',
    'settings.alarmVoltageV': '警告 (V)',
    'settings.protectionVoltageV': '保护 (V)',
    'settings.recoveryVoltageV': '恢复 (V)',
    'settings.alarmCurrentA': '警告 (A)',
    'settings.protectionCurrentA': '保护 (A)',
    'settings.recoveryCurrentA': '恢复 (A)',
    'settings.chargeProtectionCurrentA': '充电保护 (A)',
    'settings.delayUs': '延时 (μs)',
    'settings.alarmCurrentMa': '警告 (mA)',
    'settings.protectionCurrentMa': '保护 (mA)',
    'settings.recoveryCurrentMa': '恢复 (mA)',
    'settings.alarmTemp': '警告 (°C)',
    'settings.protectionTemp': '保护 (°C)',
    'settings.recoveryTemp': '恢复 (°C)',
    'settings.chargeHighTempAlarm': '充电高温警告 (°C)',
    'settings.chargeHighTempProtection': '充电高温保护 (°C)',
    'settings.dischargeHighTempAlarm': '放电高温警告 (°C)',
    'settings.chargeLowTempAlarm': '充电低温警告 (°C)',
    'settings.chargeLowTempProtection': '充电低温保护 (°C)',
    'settings.chargeLowTempRecovery': '充电低温恢复 (°C)',
    'settings.dischargeLowTempAlarm': '放电低温警告 (°C)',
    'settings.dischargeLowTempProtection': '放电低温保护 (°C)',
    'settings.dischargeLowTempRecovery': '放电低温恢复 (°C)',
    'settings.envHighTempAlarm': '环境高温警告 (°C)',
    'settings.envHighTempProtection': '环境高温保护 (°C)',
    'settings.envHighTempRecovery': '环境高温恢复 (°C)',
    'settings.envLowTempAlarm': '环境低温警告 (°C)',
    'settings.envLowTempProtection': '环境低温保护 (°C)',
    'settings.envLowTempRecovery': '环境低温恢复 (°C)',
    'settings.socPercent': 'SOC (%)',
    'settings.sleepVoltageMv': '休眠电压 (mV)',
    'settings.sleepDelayMin': '休眠延迟 (min)',
    'settings.chargeDelayMs': '充电延迟 (ms)',
    'settings.chargeProtectionCurrentMa': '充电保护电流 (mA)',
    'settings.dischargeDelayMs': '放电延迟 (ms)',

    // Balance Settings
    'settings.balance': '主动均衡参数',
    'settings.balanceDesc': '设置主动均衡的开启电压。当电芯电压大于开启电压时，主动均衡开启，当电芯电压小于开启电压时，主动均衡关闭。',
    'settings.balanceStartDiff': '开启压差',
    'settings.balanceStartVoltageMv': '开启电压 (mV)',
    'settings.balanceStartDiffMv': '开启压差 (mV)',

    // Setting Types












    'settings.fullCharge': '满充设置',
    'settings.cellSleep': '电芯休眠',
    'settings.cellSleepDesc': '当电芯电压低于休眠电压且持续时间超过延迟时间时，电池将进入休眠模式以节省电量。',
    'settings.inverterProtocol': '逆变器协议',

    // InstallationSettings Main Page
    'settings.title': '安装设置',

    'settings.sendCommandFailed': '发送指令失败',
    'settings.confirmShutdown': '确认关机/休眠',
    'settings.confirmShutdownDesc': '确定要让电池关机或进入休眠状态吗？关机后需到电池安装现场手动开机。',

    // Tabs
    'settings.tabs.control': '控制',
    'settings.tabs.protection': '保护设置',
    'settings.tabs.protocol': '协议设置',
    'settings.tabs.system': '系统设置',
    'settings.tabs.log': '设置日志',

    // Messages
    'settings.messages.fetchingProtocolSettings': '正在获取当前协议设置...',
    'settings.messages.fetchProtocolListFailed': '获取逆变器协议列表失败',
    'settings.messages.fetchingHistory': '正在读取历史记录...',
    'settings.messages.startReadingHistory': '开始读取历史记录...',
    'settings.messages.readingHistoryProgress': '正在读取第 {{current}}/{{total}} 条记录...',
    'settings.messages.protocolSetSuccess': '协议设置成功',
    'settings.messages.protocolListSuccess': '协议列表获取成功',
    'settings.messages.protocolListComplete': '协议列表获取完成！共找到 {{count}} 个协议',
    'settings.messages.protocolListCompleteCan': '协议列表获取完成！共找到 {{count}} 个CAN协议',
    'settings.messages.fetchingProtocolIds': '正在获取协议ID列表...',
    'settings.messages.fetchingCanNames': '正在获取CAN协议名称...',
    'settings.messages.fetchingRs485Names': '正在获取RS485协议名称...',



    // Support System
    'support.title': '技术支持',
    'support.newPost': '发布新帖',
    'support.editPost': '编辑帖子',
    'support.searchPlaceholder': '搜索帖子...',
    'support.filterByTag': '按标签筛选',
    'support.allTags': '所有标签',
    'support.products': '产品',
    'support.categories': '分类',
    'support.sortBy': '排序',
    'support.sortLatest': '最新',
    'support.sortPopular': '热门',
    'support.sortUnsolved': '未解决',
    'support.sortMostViewed': '最多浏览',
    'support.loadError': '加载帖子失败',
    'support.noSearchResults': '未找到匹配的帖子',
    'support.noPosts': '暂无帖子',
    'support.createFirstPost': '发布第一个帖子',
    'support.minutesAgo': '{{count}}分钟前',
    'support.hoursAgo': '{{count}}小时前',
    'support.daysAgo': '{{count}}天前',
    'support.pinned': '置顶',
    'support.locked': '已锁定',
    'support.resolved': '已解决',
    'support.private': '私密',
    'support.views': '浏览',
    'support.replies': '回复',
    'support.noReplies': '暂无回复',
    'support.backToList': '返回列表',
    'support.postNotFound': '帖子不存在',
    'support.accessDenied': '无权访问',
    'support.addReply': '添加回复',
    'support.replyPlaceholder': '输入您的回复...',
    'support.submitReply': '提交回复',
    'support.loginToReply': '登录后可回复',
    'support.postLocked': '帖子已锁定，无法回复',
    'support.bestAnswer': '最佳答案',
    'support.markBestAnswer': '标记为最佳答案',
    'support.unmarkBestAnswer': '取消最佳答案',
    'support.confirmDelete': '确认删除',
    'support.confirmDeletePost': '确定要删除这个帖子吗？',
    'support.confirmDeleteReply': '确定要删除这条回复吗？',
    'support.pin': '置顶',
    'support.unpin': '取消置顶',
    'support.lock': '锁定',
    'support.unlock': '解锁',
    'support.statusOpen': '未解决',
    'support.statusResolved': '已解决',
    'support.statusClosed': '关闭帖子',
    'support.postTitle': '帖子标题',
    'support.titlePlaceholder': '简明扼要地描述您的问题',
    'support.postContent': '详细内容',
    'support.contentPlaceholder': '详细描述您遇到的问题或建议...',
    'support.selectProduct': '选择产品',
    'support.noProduct': '无',
    'support.selectCategory': '选择分类',
    'support.categoryRequired': '请选择分类',
    'support.announcementAdminOnly': '只有管理员可以发布公告',
    'support.titleContentRequired': '标题和内容不能为空',
    'support.linkDevice': '关联设备',
    'support.linkDeviceDescription': '关联设备可以帮助我们更好地诊断问题',
    'support.selectDevice': '选择设备',
    'support.noDevice': '不关联',
    'support.packIndex': '电池包索引',
    'support.linkedDevice': '关联设备',
    'support.linkedDeviceSnapshot': '设备快照',
    'support.publicPost': '公开帖子',
    'support.privatePost': '私密帖子',
    'support.publicDescription': '所有人都可以看到此帖子',
    'support.privateDescription': '仅您和管理员可以看到此帖子',
    'support.submitPost': '发布帖子',
    'support.saveDraft': '保存草稿',
    'support.draftSaved': '草稿已保存',
    'support.similarPostsFound': '发现相似帖子，也许已有答案：',
    'support.createError': '发布失败',

    // Phase 2 additions
    'support.myPosts': '我的帖子',
    'support.myPostsTab': '我的帖子',
    'support.draftsTab': '草稿箱',
    'support.noMyPosts': '您还没有发布过帖子',
    'support.untitledDraft': '无标题草稿',
    'support.lastSaved': '上次保存',
    'support.continueDraft': '继续编辑',
    'support.deleteDraft': '删除草稿',
    'support.noDrafts': '没有保存的草稿',
    'support.addImages': '添加图片',
    'support.maxFilesError': '最多上传{{max}}张图片',
    'support.onlyImagesAllowed': '只能上传图片文件',
    'support.fileTooLarge': '文件过大（最大10MB）',
    'support.uploadFailed': '上传失败',
    'common.uploadImages': '上传图片',

    // Phase 3 additions
    'support.mentioning': '提及',

    // Phase 4 additions
    'support.adminPanel': '支持管理',
    'support.tagsTab': '标签管理',
    'support.templatesTab': '回复模板',
    'support.reportsTab': '举报管理',
    'support.addTag': '添加标签',
    'support.editTag': '编辑标签',
    'support.tagType': '标签类型',
    'support.tagColor': '标签颜色',
    'support.confirmDeleteTag': '确定要删除这个标签吗？',
    'support.addTemplate': '添加模板',
    'support.editTemplate': '编辑模板',
    'support.templateContent': '模板内容',
    'support.templatePreview': '预览',
    'support.templatePlaceholder': '支持Markdown格式...',
    'support.noTemplates': '暂无模板',
    'support.confirmDeleteTemplate': '确定要删除这个模板吗？',
    'support.useTemplate': '使用模板',
    'support.loadTemplatesError': '加载模板失败',
    'support.filterStatus': '筛选状态',
    'support.reportedContent': '被举报内容',
    'support.reportReason': '举报原因',
    'support.reporter': '举报者',
    'support.reportPending': '待处理',
    'support.reportReviewed': '已处理',
    'support.reportDismissed': '已忽略',
    'support.markReviewed': '标记已处理',
    'support.dismissReport': '忽略举报',
    'support.noReports': '暂无举报',
    'support.linkedDeviceSettings': '设置快照',

    // App specific
    // API Keys
    'apiKeys.menuTitle': 'API 密钥',
    'apiKeys.title': 'API 密钥',
    'apiKeys.description': '管理第三方集成的访问密钥',
    'apiKeys.usageWarning': '使用 API 密钥无需登录即可验证 Home Assistant 或 Grafana 等外部应用程序。请妥善保管您的密钥！',
    'apiKeys.myKeys': '我的密钥',
    'apiKeys.generateKey': '生成密钥',
    'apiKeys.keyName': '名称',
    'apiKeys.created': '创建时间',
    'apiKeys.lastUsed': '最后使用',
    'apiKeys.noKeys': '未找到 API 密钥',
    'apiKeys.integrationExamples': '集成示例',
    'apiKeys.haTitle': 'Home Assistant (REST 传感器)',
    'apiKeys.haInstructions': '将此添加到您的 configuration.yaml：',
    'apiKeys.curlTitle': 'cURL / 终端',
    'apiKeys.generateDialogTitle': '生成 API 密钥',
    'apiKeys.keyNameLabel': '密钥名称 (例如: Home Assistant)',
    'apiKeys.generateAction': '生成',
    'apiKeys.successDialogTitle': 'API 密钥已生成',
    'apiKeys.copyWarning': '立即复制此密钥。您将无法再次看到它！',
    'apiKeys.createError': '创建 API 密钥失败',
    'apiKeys.deleteError': '删除密钥失败',
    'apiKeys.loadError': '加载 API 密钥失败',

    // Settings
    'settings.deleteAccount': '删除账户',
    'settings.deleteAccountDesc': '一旦删除账户，将无法撤销。请谨慎操作。',
    'settings.deleteAccountConfirm': '您确定要删除您的账户吗？',
    'settings.deleteAccountWarning': '此操作是永久性的，无法撤销。',
    'settings.deleteAccountSuccess': '账户已成功删除',
  },
};

export default zh;